/* eslint-disable react/button-has-type */
/* eslint-disable import/order */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/self-closing-comp */

import React, { useEffect, useState } from "react";
import { CircularProgress, Card, CardContent, Button, Dialog, DialogContent, IconButton, Snackbar, Alert } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Pencil, Eye } from "lucide-react";
import adminServices from '../../../services/adminServices';
import Page from "../../../components/Page";
import ScoringTable from "./assessmentscore";

export default function ExamCategoriesPage() {
  const [openScoring, setOpenScoring] = useState(false);
  const [openPreview, setOpenPreview] = useState(false);
  const [viewData, setViewData] = useState(null);
  const [scoreDetails, setScoreDetails] = useState([]);
  const [editData, setEditData] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [deleteId, setDeleteId] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    getassessmentscore();
  }, []);

  const getassessmentscore = async () => {
    const result = await adminServices.getassessmentscore(0, 10);
    setScoreDetails(result.data?.details?.data);
  };

  const handleSubmitScore = async (data) => {
    const score = await adminServices.AssessmentScore(data);
    if (score.ok) {
      setOpenScoring(false);
      getassessmentscore();
      setSnackbar({
        open: true,
        message: data?.id ? "Score table updated successfully" : "Score table created successfully",
        severity: "success",
      });
    }
  };

  const getScoreRange = (scaleScore = {}) => {
    const vals = Object.values(scaleScore).filter(Boolean);
    if (!vals.length) return "—";
    const nums = vals.flatMap(v => v.toString().split("-").map(Number));
    return `${Math.min(...nums)} – ${Math.max(...nums)}`;
  };


  const handleDelete = async () => {
    try {
      setDeleting(true);
      const res = await adminServices.DeleteAssessmentscore(deleteId);
      if (res.ok) {
        setSnackbar({
          open: true,
          message: "Score template deleted successfully",
          severity: "success",
        });
        setOpenDelete(false);
        getassessmentscore();
      } else {
        setSnackbar({
          open: true,
          message: res.data?.message || "Unable to delete. Template is in use.",
          severity: "error",
        });
      }
    } catch (e) {
      setSnackbar({
        open: true,
        message: e.message,
        severity: "error",
      });
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Page title="">
      <div className="p-6 bg-gray-50 min-h-screen">
        <div className="mb-6">
          <h1 className="text-2xl font-semibold">Platform Config</h1>
          <p className="text-sm text-gray-500">
            Manage exam categories, concept tags, and analytics display.
          </p>
        </div>

        <Card className="rounded-2xl shadow-sm">
          <CardContent className="p-0">
            <div className="flex items-center justify-between px-6 py-4 border-b bg-white">
              <h2 className="text-lg font-semibold">Exam Category</h2>
              <button
                onClick={() => { setEditData(null); setOpenScoring(true); }}
                className="ml-auto px-6 py-2.5 rounded-md text-sm font-semibold text-white shadow bg-blue-600 hover:bg-blue-700 transition"
              >
                Create Exam Category
              </button>
            </div>

            <div className="grid grid-cols-12 px-6 py-3 text-xs font-semibold text-gray-500 border-b bg-gray-50">
              <div className="col-span-3">DISPLAY NAME</div>
              <div className="col-span-2">CATEGORY</div>
              <div className="col-span-2">NO OF QUESTIONS</div>
              <div className="col-span-2">ASSESSMENTS USED</div>
              <div className="col-span-3 text-center">ACTIONS</div>
            </div>

            <div className="divide-y">
  {scoreDetails && scoreDetails.length > 0 && scoreDetails.map((r) => (
    <div
      key={r.id}
      className="grid grid-cols-12 items-center px-6 py-4 bg-white hover:bg-gray-50 transition"
    >


      <div className="col-span-3 font-medium text-gray-800">
        {r?.template_name}
      </div>

      <div className="col-span-2 font-medium text-gray-800">
        {r?.assessment_type_code}
      </div>

      <div className="col-span-2 font-medium text-gray-800">
        {r?.qn_count}
      </div>

      <div className="col-span-2 font-medium text-gray-800">
        {r?.assessment_count}
      </div>

      <div className="col-span-3 flex justify-end gap-2">
      <Button onClick={() => { setViewData(r); setOpenPreview(true); }} variant="outlined" size="small"> <Eye size={14} className="mr-1" /> View </Button>
       <Button onClick={() => { setEditData(r); setOpenScoring(true); }} variant="outlined" size="small" > <Pencil size={14} className="mr-1" /> Edit </Button>
        <Button onClick={() => { setDeleteId(r.id); setOpenDelete(true); }} variant="outlined" color="error" size="small">Delete</Button>
      </div>
    </div>
  ))}
</div>
          </CardContent>
        </Card>
      </div>

      <Dialog open={openScoring} onClose={() => setOpenScoring(false)} fullScreen maxWidth={false}>
        <DialogContent style={{ padding: 0 }}>
          <IconButton onClick={() => setOpenScoring(false)} style={{ position: "absolute", right: 6, top: 16, zIndex: 10 }}>
            <CloseIcon />
          </IconButton>
          <ScoringTable
            sections={[]}
            variants={[]}
            scoreDetails={editData}
            handleSubmitScore={handleSubmitScore}
          />
        </DialogContent>
      </Dialog>

      <Dialog open={openPreview}
        onClose={() => setOpenPreview(false)}
        maxWidth="sm" fullWidth>
        <DialogContent style={{ padding: 0 }}>
          <IconButton onClick={() => setOpenPreview(false)}
            style={{ position: "absolute", right: 12, top: 12, zIndex: 10 }}>
            <CloseIcon />
          </IconButton>

          {viewData && (
            <div className="p-6">
              <div className="flex items-start justify-between mb-4 pr-8">
                <div>
                  <h2 className="text-lg font-semibold text-gray-800">{viewData.template_name}</h2>
                  <p className="text-sm text-gray-500 mt-0.5">Score details &amp; raw-to-scaled mapping</p>
                </div>
                <span className="inline-block mt-1 px-3 py-0.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700">
                  {viewData.assessment_type_code}
                </span>
              </div>

              <div className="grid grid-cols-3 gap-4 mb-5">
                {[
                  { label: "Questions per attempt", value: viewData.qn_count },
                  { label: "Score entries", value: Object.keys(viewData.scale_score || {}).length },
                  { label: "Score range", value: getScoreRange(viewData.scale_score) },
                ].map(({ label, value }) => (
                  <div key={label} className="bg-gray-50 rounded-lg p-3">
                    <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">{label}</p>
                    <p className="text-base font-semibold text-gray-800">{value}</p>
                  </div>
                ))}
              </div>

              <div className="border rounded-lg overflow-hidden">
                <div className="grid grid-cols-2 bg-gray-50 px-5 py-2.5 text-xs font-semibold text-gray-500 uppercase tracking-wide border-b">
                  <span>Raw score</span>
                  <span>Scaled score</span>
                </div>
                <div className="max-h-72 overflow-y-auto divide-y">
                  {viewData.scale_score && Object.keys(viewData.scale_score).length > 0 ? (
                    Object.entries(viewData.scale_score).map(([raw, scaled]) => (
                      <div key={raw} className="grid grid-cols-2 px-5 py-3 hover:bg-gray-50 text-sm">
                        <span className="text-gray-500">{raw}</span>
                        <span className="font-medium text-gray-800">{scaled || "—"}</span>
                      </div>
                    ))
                  ) : (
                    <div className="px-5 py-8 text-center text-sm text-gray-400">
                      No score mapping available
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          variant="filled"
          sx={{
            backgroundColor: "#4B5563",
            color: "#fff",
            "& .MuiAlert-icon": { color: "#fff" },
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Dialog 
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogContent>
          <h2 className="text-lg font-semibold mb-2">Delete Score Template?</h2>
          <p className="text-sm text-gray-600 mb-6">
            This action cannot be undone. If this template is used in any assessment,
            deletion will be blocked.
          </p>

          <div className="flex justify-end gap-3">
            <Button
              onClick={() => setOpenDelete(false)}
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              onClick={handleDelete}
              color="error"
              variant="contained"
              disabled={deleting}
              startIcon={
                deleting ? <CircularProgress size={16} color="inherit" /> : null
              }
            >
              {deleting ? "Deleting..." : "Confirm Delete"}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </Page>
  );
}